import React, {useEffect, useRef} from 'react';
import {inject, observer} from 'mobx-react';
import ContextMenuProviderStore from '../store/ContextMenuProviderStore';

interface Props {
  contextMenuProviderStore?: ContextMenuProviderStore;
}

const ContextMenuProviderContainer = inject('contextMenuProviderStore')(
  observer(({contextMenuProviderStore}: Props) => {
    const menu = contextMenuProviderStore?.menu;
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (!menu) return;

      const handleClickOutside = (e: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
          contextMenuProviderStore?.close();
        }
      };

      const handleScroll = () => {
        contextMenuProviderStore?.close();
      };

      document.addEventListener('mousedown', handleClickOutside);
      window.addEventListener('scroll', handleScroll, true);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        window.removeEventListener('scroll', handleScroll, true);
      };
    }, [menu, contextMenuProviderStore]);

    if (!menu) return null;

    return (
      <div
        ref={menuRef}
        style={{
          position: 'fixed',
          top: menu.position.y,
          left: menu.position.x,
          zIndex: 9999,
        }}>
        {menu.content}
      </div>
    );
  }),
);

export default ContextMenuProviderContainer;
